<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>New Application :</strong>
  <mat-icon class="close-btn" (click)="onNoClick()">close</mat-icon>
</h1>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit(f)" #f="ngForm">
  <div mat-dialog-content>
    <mat-form-field fxFill appearance="fill">
      <mat-label>Application Name </mat-label>
      <input matInput type="text" id="name" name="name" class="form-control" ngModel required #name="ngModel" />
      @if (name.hasError('required')) {
      <mat-error>You must enter a name </mat-error>
      }
    </mat-form-field>
    <mat-form-field fxFill appearance="fill">
      <mat-label>Status </mat-label>
      <mat-select placeholder="Select a status" name="status" id="status" class="form-control" ngModel required>
        <mat-option value="verif">verif</mat-option>
        <mat-option value="actif">Actif</mat-option>
        <mat-option value="processing">processing</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="btn-container">
    <button mat-stroked-button color="primary" type="submit" [disabled]="!f.valid">Submit</button>
  </div>
</form>
